/**
 * Wedding Band Configurator
 * Pairs with wedding-band-configurator.liquid + wedding-band-customizer.css
 */
(function () {
  const root = document.querySelector('[data-wbc-root]');
  if (!root) return;

  // Naya Tabs Section ka root
  const tabsRoot = document.querySelector('[data-wbc-tabs-root]');

  const els = {
    mainImage: root.querySelector('[data-wbc-main-image]'),
    mainVideo: root.querySelector('[data-wbc-main-video]'),
    prevBtn: root.querySelector('[data-wbc-prev]'),
    nextBtn: root.querySelector('[data-wbc-next]'),
    mmCaption: root.querySelector('[data-wbc-mm-caption]'),
    thumbs: root.querySelector('[data-wbc-thumbs]'),
    loading: root.querySelector('[data-wbc-loading]'),
    title: root.querySelector('[data-wbc-title]'),
    currentPrice: root.querySelector('[data-wbc-current-price]'),
    comparePrice: root.querySelector('[data-wbc-compare-price]'),
    saleLabel: root.querySelector('[data-wbc-sale-label]'),
    saveBanner: root.querySelector('[data-wbc-save-banner]'),
    shapeOptions: root.querySelector('[data-wbc-shape-options]'),
    styleOptions: root.querySelector('[data-wbc-style-options]'),
    dynamicOptions: root.querySelector('[data-wbc-dynamic-options]'),
    specShape: root.querySelector('[data-wbc-spec-shape]'),
    qtyInput: root.querySelector('[data-wbc-qty]'),
    qtyIncrease: root.querySelector('[data-wbc-qty-increase]'),
    qtyDecrease: root.querySelector('[data-wbc-qty-decrease]'),
    qtyError: root.querySelector('[data-wbc-qty-error]'),
    addToCart: root.querySelector('[data-wbc-add-to-cart]'),
    unavailable: root.querySelector('[data-wbc-unavailable]'),

    // Tab elements (Naye section se)
    descriptionEl: tabsRoot ? tabsRoot.querySelector('[data-wbc-description]') : null,
    tabButtons: tabsRoot ? tabsRoot.querySelectorAll('[data-wbc-tab]') : [],
    tabPanes: tabsRoot ? tabsRoot.querySelectorAll('[data-wbc-tab-content]') : []
  };

  const WBC_MAX_QTY = 5;

  function normalize(str) {
    return (str || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }
  function uniqueByNormalized(values) {
    const seen = new Map();
    values.forEach(v => {
      const key = normalize(v);
      if (!seen.has(key)) seen.set(key, (v || '').trim());
    });
    return [...seen.values()];
  }
  function capitalize(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : str;
  }
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  const comboList = (window.__WBC_COMBOS__ || []).filter(c => c.shape && c.style);
  const comboMap = {};
  comboList.forEach(({ shape, style, handle }) => {
    const s = normalize(shape);
    const st = normalize(style);
    comboMap[s] = comboMap[s] || {};
    comboMap[s][st] = handle;
  });

  const uniqueShapes = uniqueByNormalized(comboList.map(c => c.shape));
  const uniqueStyles = uniqueByNormalized(comboList.map(c => c.style));

  const shapeImageLookup = (function () {
    const lookup = {};
    comboList.forEach(c => {
      const key = normalize(c.shape);
      if (c.shapeImage && !lookup[key]) lookup[key] = c.shapeImage;
    });
    return lookup;
  })();
  const shapeImageWhiteLookup = (function () {
    const lookup = {};
    comboList.forEach(c => {
      const key = normalize(c.shape);
      if (c.shapeImageWhite && !lookup[key]) lookup[key] = c.shapeImageWhite;
    });
    return lookup;
  })();
  const styleImageLookup = (function () {
    const lookup = {};
    comboList.forEach(c => {
      const key = normalize(c.style);
      if (c.styleImage && !lookup[key]) lookup[key] = c.styleImage;
    });
    return lookup;
  })();

  const initialMetafieldsEl = document.querySelector('[data-wbc-metafields]');

  // PERF: warm up the connection to the video CDN as early as possible so
  // that if/when the shopper clicks the video thumbnail, playback starts
  // immediately instead of waiting for DNS + TLS handshake first.
  function preconnectTo(url) {
    try {
      const origin = new URL(url, window.location.href).origin;
      if (document.querySelector(`link[rel="preconnect"][href="${origin}"]`)) return;
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = origin;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    } catch (e) { /* ignore malformed URLs */ }
  }
  if (initialMetafieldsEl) {
    try {
      const initialVideoUrl = JSON.parse(initialMetafieldsEl.textContent).video_url;
      if (initialVideoUrl) preconnectTo(initialVideoUrl);
    } catch (e) { /* ignore */ }
  }

  const state = {
    shape: (window.__WBC_INITIAL_SHAPE__ || uniqueShapes[0] || '').trim(),
    style: (window.__WBC_INITIAL_STYLE__ || uniqueStyles[0] || '').trim(),
    currentHandle: root.dataset.productHandle || null,
    productUrl: root.dataset.productUrl || window.location.pathname,
    currentMetafields: initialMetafieldsEl ? JSON.parse(initialMetafieldsEl.textContent) : {},
    unitPrice: 0,
    media: [],
    imageIndex: 0
  };

  // Pehle images, aur sabse LAST me video
  function buildMediaList(targetDoc) {
    const target = targetDoc || root;
    const mediaList = [];

    // 1. Collect product images first
    const thumbImgs = target.querySelectorAll('[data-wbc-thumbs] img:not(.wbc__thumb--video video)');
    thumbImgs.forEach(img => {
      const full = img.getAttribute('data-full') || img.getAttribute('src');
      if (full) {
        mediaList.push({ type: 'image', src: full });
      }
    });

    // 2. Add video at the LAST position if present
    const videoUrl = state.currentMetafields && state.currentMetafields.video_url;
    if (videoUrl && typeof videoUrl === 'string' && videoUrl.trim() !== '') {
      mediaList.push({ type: 'video', src: videoUrl.trim() });
    }

    return mediaList;
  }

  // ---------------------------------------------------------------------------
  // Shape / Style buttons
  // ---------------------------------------------------------------------------
  function renderTopLevelButtons(container, values, selectedValue, imageLookup, whiteImageLookup, extraClass, useWhiteOnSelect, onSelect) {
    container.innerHTML = '';
    values.forEach(value => {
      const btn = document.createElement('button');
      btn.type = 'button';
      const isSelected = normalize(value) === normalize(selectedValue);
      btn.className = 'wbc__btn wbc__btn--icon' + (extraClass ? ' ' + extraClass : '');
      if (isSelected) btn.classList.add('is-selected');

      const defaultSrc = imageLookup[normalize(value)];
      const whiteSrc = whiteImageLookup ? whiteImageLookup[normalize(value)] : null;

      const useWhite = isSelected && useWhiteOnSelect;
      const activeSrc = useWhite ? (whiteSrc || defaultSrc) : defaultSrc;
      const needsAutoTint = useWhite && !whiteSrc && !!defaultSrc;

      if (activeSrc) {
        const img = document.createElement('img');
        img.className = 'wbc__icon-image' + (needsAutoTint ? ' wbc__icon-image--auto-tint' : '');
        img.src = activeSrc;
        img.alt = value;
        btn.appendChild(img);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'wbc__icon-placeholder';
        btn.appendChild(placeholder);
      }

      const label = document.createElement('span');
      label.className = 'wbc__icon-label';
      label.textContent = capitalize(value);
      btn.appendChild(label);

      btn.addEventListener('click', () => onSelect(value));
      container.appendChild(btn);
    });
  }

  function renderShapeButtons() {
    renderTopLevelButtons(els.shapeOptions, uniqueShapes, state.shape, shapeImageLookup, shapeImageWhiteLookup, 'wc__shape-icon', true, (value) => {
      state.shape = value;
      if (els.specShape) els.specShape.textContent = capitalize(value);
      renderShapeButtons();
      handleComboChange();
    });
    if (els.specShape) els.specShape.textContent = capitalize(state.shape);
  }

  function renderStyleButtons() {
    renderTopLevelButtons(els.styleOptions, uniqueStyles, state.style, styleImageLookup, null, 'wc__band-icons', false, (value) => {
      state.style = value;
      renderStyleButtons();
      handleComboChange();
    });
  }

  // ---------------------------------------------------------------------------
  // Section cache + fast switching
  // ---------------------------------------------------------------------------
  const sectionCache = new Map(); // url -> html string
  let activeAbortController = null;
  let spinnerTimeout = null;

  async function refreshSection(url) {
    // Cancel any in-flight request so an old, slower response can never
    // land after a newer one (prevents flicker / wrong-combo flash).
    if (activeAbortController) {
      activeAbortController.abort();
      activeAbortController = null;
    }
    clearTimeout(spinnerTimeout);

    // Instant path: this exact combo was already fetched before (or prefetched).
    if (sectionCache.has(url)) {
      setLoading(false);
      const doc = new DOMParser().parseFromString(sectionCache.get(url), 'text/html');
      applySectionUpdate(doc);
      showUnavailable(false);
      return;
    }

    const controller = new AbortController();
    activeAbortController = controller;

    // Only show the spinner if the request is actually slow (>150ms).
    // Fast responses feel instant with no spinner flash at all.
    spinnerTimeout = setTimeout(() => setLoading(true), 150);

    try {
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) throw new Error('Section refresh failed: ' + res.status);
      const html = await res.text();
      sectionCache.set(url, html);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      applySectionUpdate(doc);
      showUnavailable(false);
    } catch (err) {
      if (err.name === 'AbortError') return; // superseded by a newer click
      console.error('[wbc] refreshSection failed', err);
      showUnavailable(true);
    } finally {
      clearTimeout(spinnerTimeout);
      setLoading(false);
      if (activeAbortController === controller) activeAbortController = null;
    }
  }

  // Quietly buffer the CURRENT product's video in the background so the
  // first click on the video thumbnail feels instant.
  // `immediate: true` (used for the page's own video, right at load) starts
  // downloading right away — at LOW network priority via fetchPriority, so
  // it never competes with the hero image, fonts or CSS — because a fresh
  // first-time visitor has zero cache and the video needs every millisecond
  // it can get before they click. `immediate: false` (used after a
  // shape/style switch) waits for an idle moment instead, since that's a
  // lower-urgency, secondary combo the shopper may never click video on.
  function preloadMainVideoInBackground(immediate) {
    const videoUrl = state.currentMetafields && state.currentMetafields.video_url;
    if (!videoUrl || !els.mainVideo) return;
    if (els.mainVideo.dataset.loadedSrc === videoUrl) return; // already loading/loaded

    const run = () => {
      // Re-check: state may have moved on (combo switched) while we waited.
      const latestUrl = state.currentMetafields && state.currentMetafields.video_url;
      if (latestUrl !== videoUrl || els.mainVideo.dataset.loadedSrc === videoUrl) return;
      els.mainVideo.dataset.loadedSrc = videoUrl;
      els.mainVideo.preload = 'auto';
      try { els.mainVideo.fetchPriority = 'low'; } catch (e) { /* older browsers: ignore */ }
      els.mainVideo.src = videoUrl;
      els.mainVideo.load();
    };

    if (immediate) {
      run();
      return;
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 1500 });
    } else {
      setTimeout(run, 400);
    }
  }

  // Quietly prefetch every shape+style combo in idle time after first paint,
  // so later switches are served from cache (instant) instead of network.
  function prefetchCombos() {
    if (!window.__WBC_SECTION_ID__) return;
    const urls = comboList
      .filter(c => c.handle && c.handle !== state.currentHandle)
      .map(c => `/products/${c.handle}?section_id=${window.__WBC_SECTION_ID__}`)
      .filter((url, i, arr) => arr.indexOf(url) === i); // dedupe

    let i = 0;
    function prefetchNext() {
      if (i >= urls.length) return;
      const url = urls[i++];
      if (sectionCache.has(url)) {
        schedule();
        return;
      }
      fetch(url)
        .then(res => (res.ok ? res.text() : null))
        .then(html => {
          if (!html) return;
          sectionCache.set(url, html);
          // Also warm the browser's own image cache for this combo's photo,
          // so when the shopper actually switches to it there's no
          // "torn corner" loading flash — the bytes are already local.
          try {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const firstThumb = doc.querySelector('[data-wbc-thumbs] img');
            const fullSrc = firstThumb && (firstThumb.getAttribute('data-full') || firstThumb.getAttribute('src'));
            if (fullSrc) { const img = new Image(); img.src = fullSrc; }
          } catch (e) { /* ignore parse errors */ }
        })
        .catch(() => {})
        .finally(schedule);
    }
    function schedule() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(prefetchNext, { timeout: 2000 });
      } else {
        setTimeout(prefetchNext, 250);
      }
    }
    schedule();
  }

  function applySectionUpdate(doc) {
    const newRoot = doc.querySelector('[data-wbc-root]');
    if (!newRoot) return;

    state.currentHandle = newRoot.dataset.productHandle || state.currentHandle;
    state.productUrl = newRoot.dataset.productUrl || state.productUrl;

    const newTitle = newRoot.querySelector('[data-wbc-title]');
    if (newTitle) els.title.textContent = newTitle.textContent;

    const newPriceBox = newRoot.querySelector('[data-wbc-price-box]');
    if (newPriceBox) {
      const oldPriceBox = root.querySelector('[data-wbc-price-box]');
      if (oldPriceBox) oldPriceBox.replaceWith(newPriceBox);
      els.comparePrice = root.querySelector('[data-wbc-compare-price]');
      els.saleLabel = root.querySelector('[data-wbc-sale-label]');
      els.saveBanner = root.querySelector('[data-wbc-save-banner]');
      els.currentPrice = root.querySelector('[data-wbc-current-price]');
      if (els.currentPrice && els.currentPrice.dataset.unitPriceCents) {
        state.unitPrice = parseInt(els.currentPrice.dataset.unitPriceCents, 10);
      }
    }

    const newDynamic = newRoot.querySelector('[data-wbc-dynamic-options]');
    if (newDynamic) {
      els.dynamicOptions.replaceWith(newDynamic);
      els.dynamicOptions = newDynamic;
      applyMetalSwatchStyling();
      els.specShape = root.querySelector('[data-wbc-spec-shape]');
    }

    const newAddToCart = newRoot.querySelector('[data-wbc-add-to-cart]');
    if (newAddToCart) {
      els.addToCart.dataset.variantId = newAddToCart.dataset.variantId || '';
      els.addToCart.disabled = newAddToCart.hasAttribute('disabled');
      const newLabelEl = newAddToCart.querySelector('.wbc__atc-label');
      const labelEl = els.addToCart.querySelector('.wbc__atc-label');
      if (labelEl && newLabelEl) labelEl.textContent = newLabelEl.textContent.trim();
    }

    const newDescription = doc.querySelector('[data-wbc-description]');
    if (newDescription && els.descriptionEl) {
      els.descriptionEl.innerHTML = formatDescriptionToTable(newDescription.innerHTML);
    }

    const newMetafieldsEl = doc.querySelector('[data-wbc-metafields]');
    state.currentMetafields = newMetafieldsEl ? JSON.parse(newMetafieldsEl.textContent) : {};

    // Rebuild media list & update gallery
    state.media = buildMediaList(newRoot);
    state.imageIndex = 0;
    // Crossfade transition (same as every other gallery navigation).
    updateGallery();

    updateMmCaptionFromDom();
    updateTotalPrice();
    updateQtyControls();

    const newSpecShape = root.querySelector('[data-wbc-spec-shape]');
    if (newSpecShape) newSpecShape.textContent = capitalize(state.shape);

    // The new combo's video (if any) hasn't been buffered yet — start
    // warming it quietly in the background too (idle is fine here, this
    // is a secondary combo, not the shopper's very first page load).
    preloadMainVideoInBackground(false);
  }

  async function handleComboChange() {
    const shapeKey = normalize(state.shape);
    const styleKey = normalize(state.style);
    const targetHandle = comboMap[shapeKey] && comboMap[shapeKey][styleKey];

    renderStyleButtons();

    if (!targetHandle) {
      showUnavailable(true);
      return;
    }
    if (targetHandle === state.currentHandle) return;

    await refreshSection(`/products/${targetHandle}?section_id=${window.__WBC_SECTION_ID__}`);
  }

  function formatDescriptionToTable(htmlContent) {
    if (!htmlContent) return '<p>No description available.</p>';

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    const listItems = tempDiv.querySelectorAll('ul li, ol li');

    if (listItems.length > 0) {
      let tableHTML = '<table class="wbc-desc-table">';

      listItems.forEach(li => {
        const text = li.textContent.trim();
        const parts = text.split(':');

        if (parts.length >= 2) {
          const label = parts[0].trim();
          const value = parts.slice(1).join(':').trim();
          tableHTML += `<tr><td class="wbc-desc-label">${label}</td><td class="wbc-desc-value">${value}</td></tr>`;
        } else {
          tableHTML += `<tr><td colspan="2" class="wbc-desc-full">${text}</td></tr>`;
        }
      });

      tableHTML += '</table>';

      const remainingHTML = tempDiv.innerHTML.replace(/<[uo]l>[\s\S]*?<\/[uo]l>/g, '');
      return tableHTML + remainingHTML;
    }

    const paragraphs = tempDiv.querySelectorAll('p');
    if (paragraphs.length > 0) {
      let hasColon = false;
      paragraphs.forEach(p => {
        if (p.textContent.includes(':')) hasColon = true;
      });

      if (hasColon) {
        let tableHTML = '<table class="wbc-desc-table">';
        paragraphs.forEach(p => {
          const text = p.textContent.trim();
          if (text.includes(':')) {
            const parts = text.split(':');
            const label = parts[0].trim();
            const value = parts.slice(1).join(':').trim();
            tableHTML += `<tr><td class="wbc-desc-label">${label}</td><td class="wbc-desc-value">${value}</td></tr>`;
          } else {
            tableHTML += `<tr><td colspan="2" class="wbc-desc-full">${text}</td></tr>`;
          }
        });
        tableHTML += '</table>';
        return tableHTML;
      }
    }

    return htmlContent;
  }

  function updateTotalPrice() {
    const qty = clampQty(parseInt(els.qtyInput.value || '1', 10));
    const discount = Number(state.currentMetafields.discount_percentage || 0);
    const baseTotal = state.unitPrice * qty;

    if (discount > 0) {
      const discountedTotal = Math.round(baseTotal * (1 - discount / 100));
      const savings = baseTotal - discountedTotal;

      els.comparePrice.textContent = formatMoney(baseTotal);
      els.comparePrice.hidden = false;
      els.saleLabel.hidden = false;
      els.saveBanner.textContent = `Save ${formatMoney(savings)} with ${discount}% OFF`;
      els.saveBanner.hidden = false;

      els.currentPrice.textContent = formatMoney(discountedTotal);
    } else {
      els.comparePrice.hidden = true;
      els.saleLabel.hidden = true;
      els.saveBanner.hidden = true;

      els.currentPrice.textContent = formatMoney(baseTotal);
    }
  }

  function toImageUrl(src, width) {
    if (!src) return '';
    const base = typeof src === 'string' ? src : (src.src || src.url || '');
    if (!base) return '';
    if (!width) return base;
    return base.replace(/(\.[a-zA-Z]+)(\?.*)?$/, `_${width}x$1$2`);
  }

  // ---------------------------------------------------------------------------
  // Gallery update (crossfade for every navigation — arrows, thumbnails, combo switch)
  // ---------------------------------------------------------------------------
  function updateGallery() {
    const media = state.media || [];
    if (!media.length) return;
    if (state.imageIndex >= media.length) state.imageIndex = 0;
    if (state.imageIndex < 0) state.imageIndex = media.length - 1;

    const currentItem = media[state.imageIndex];
    const galleryMain = els.mainImage ? els.mainImage.closest('.wbc__gallery-main') : null;

    if (currentItem.type === 'video') {
      if (els.mainImage) {
        els.mainImage.hidden = true;
        els.mainImage.style.display = 'none';
      }
      if (els.mainVideo) {
        const alreadyStarted = els.mainVideo.dataset.loadedSrc === currentItem.src;
        // HAVE_FUTURE_DATA (3) or better means it can play through this
        // point without stalling — safe to skip the spinner entirely.
        const isBuffered = alreadyStarted && els.mainVideo.readyState >= 3;

        els.mainVideo.hidden = false;
        els.mainVideo.style.display = 'block';

        if (!alreadyStarted) {
          // Background preload never got to this video (e.g. very fast
          // click) — start loading now and show the spinner meanwhile.
          setLoading(true);
          els.mainVideo.dataset.loadedSrc = currentItem.src;
          els.mainVideo.preload = 'auto';
          els.mainVideo.src = currentItem.src;
          const onReady = () => {
            setLoading(false);
            els.mainVideo.removeEventListener('canplay', onReady);
            els.mainVideo.removeEventListener('error', onReady);
          };
          els.mainVideo.addEventListener('canplay', onReady, { once: true });
          els.mainVideo.addEventListener('error', onReady, { once: true });
          els.mainVideo.load();
        } else if (!isBuffered) {
          // Preload started in the background but hasn't buffered enough
          // yet — briefly show the spinner until it catches up.
          setLoading(true);
          const onReady = () => {
            setLoading(false);
            els.mainVideo.removeEventListener('canplay', onReady);
            els.mainVideo.removeEventListener('error', onReady);
          };
          els.mainVideo.addEventListener('canplay', onReady, { once: true });
          els.mainVideo.addEventListener('error', onReady, { once: true });
        }
        // else: already buffered by the background preload — instant, no spinner.

        const playPromise = els.mainVideo.play();
        if (playPromise !== undefined) {
          playPromise.catch(err => {
            console.log('[wbc] Autoplay notice:', err);
          });
        }
      }
    } else {
      if (els.mainVideo) {
        els.mainVideo.pause();
        els.mainVideo.hidden = true;
        els.mainVideo.style.display = 'none';
      }
      if (els.mainImage) {
        // Smooth crossfade for every navigation — arrows, thumbnails, and combo switches.
        const nextSrc = toImageUrl(currentItem.src, 900);
        if (els.mainImage.src !== nextSrc) {
          if (galleryMain) galleryMain.classList.add('is-swapping');
          const preload = new Image();
          preload.onload = preload.onerror = () => {
            els.mainImage.src = nextSrc;
            if (galleryMain) galleryMain.classList.remove('is-swapping');
          };
          preload.src = nextSrc;
        }
        els.mainImage.hidden = false;
        els.mainImage.style.display = 'block';
      }
    }

    els.thumbs.innerHTML = '';
    media.forEach((item, i) => {
            if (item.type === 'video') {
        const thumbBox = document.createElement('div');
        thumbBox.className = 'wbc__thumb wbc__thumb--video' + (i === state.imageIndex ? ' is-active' : '');

        const thumbVideo = document.createElement('video');
        thumbVideo.src = item.src;
        thumbVideo.autoplay = true;
        thumbVideo.muted = true;
        thumbVideo.loop = true;
        thumbVideo.playsInline = true;
        thumbVideo.preload = 'auto';
        thumbBox.appendChild(thumbVideo);

        const playIcon = document.createElement('span');
        playIcon.className = 'wbc__thumb-play-icon';
        playIcon.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';

        thumbBox.appendChild(playIcon);

        thumbBox.addEventListener('click', () => {
          state.imageIndex = i;
          updateGallery();
        });
        els.thumbs.appendChild(thumbBox);
      } else {
        const img = document.createElement('img');
        img.className = 'wbc__thumb' + (i === state.imageIndex ? ' is-active' : '');
        img.src = toImageUrl(item.src, 150);
        img.setAttribute('data-full', toImageUrl(item.src, 900));
        img.alt = els.title ? els.title.textContent : '';
        img.addEventListener('click', () => {
          state.imageIndex = i;
          updateGallery();
        });
        els.thumbs.appendChild(img);
      }
    });
  }

  function goPrevImage() {
    const media = state.media || [];
    if (!media.length) return;
    state.imageIndex = (state.imageIndex - 1 + media.length) % media.length;
    updateGallery();
  }

  function goNextImage() {
    const media = state.media || [];
    if (!media.length) return;
    state.imageIndex = (state.imageIndex + 1) % media.length;
    updateGallery();
  }

  els.prevBtn.type = 'button';
  els.nextBtn.type = 'button';

  // FIX: only ONE listener per button now. Pehle button par direct listener
  // ke saath-saath ek document-level (capturing) listener bhi tha jo isi
  // click ko dobara match kar leta tha -> goNextImage()/goPrevImage() ek
  // click par 2 baar fire hota tha -> index ek click me 2 aage badh jaata
  // tha (image 1 se seedha image 3, image 2 skip). Woh duplicate listener
  // hata diya gaya hai, ab step-by-step (ek click = ek image) slide hoga.
  els.prevBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); goPrevImage(); });
  els.nextBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); goNextImage(); });

  function updateMmCaptionFromDom() {
    const groups = els.dynamicOptions.querySelectorAll('[data-wbc-option-group]');
    let mmValue = null;
    groups.forEach(group => {
      const selectedBtn = group.querySelector('.wbc__ring-btn.is-selected[data-wbc-option-value]');
      if (selectedBtn && /mm/i.test(selectedBtn.textContent)) {
        mmValue = selectedBtn.textContent.trim();
      }
    });
    if (mmValue) {
      els.mmCaption.textContent = mmValue;
      els.mmCaption.hidden = false;
    } else {
      els.mmCaption.hidden = true;
    }
  }

  function classifyMetal(rawValue) {
    const v = (rawValue || '').toLowerCase().replace(/\s+/g, '');
    if (/silver|sterling|\bss\d*\b/.test(v)) return 'silver';
    if (/platinum|\bpt\d*\b/.test(v)) return 'platinum';
    if (/rose/.test(v)) return 'rose';
    if (/yellow/.test(v)) return 'yellow';
    if (/white/.test(v)) return 'white';
    const shorthand = v.match(/\d{1,2}k-?([ywr])\b/);
    if (shorthand) {
      const letter = shorthand[1];
      if (letter === 'y') return 'yellow';
      if (letter === 'w') return 'white';
      if (letter === 'r') return 'rose';
    }
    return 'unknown';
  }

  const metalCategoryColors = {
    silver: '#C7C7C7', platinum: '#E2E2E2', white: '#E7E7E9',
    yellow: '#FFD400', rose: '#E7B29C', unknown: '#E5E5E5'
  };
  function getMetalColor(value) { return metalCategoryColors[classifyMetal(value)]; }

  function applyMetalSwatchStyling() {
    els.dynamicOptions.querySelectorAll('.wbc__btn--metal').forEach(btn => {
      const color = getMetalColor(btn.textContent.trim());
      if (btn.classList.contains('is-selected')) {
        btn.style.setProperty('border-color', '#2c2c54', 'important');
        btn.style.setProperty('background-color', '#2c2c54', 'important');
      } else {
        btn.style.setProperty('border-color', 'transparent', 'important');
        btn.style.setProperty('background-color', color, 'important');
      }
    });
  }

  function collectSelectedOptionValueIds() {
    const ids = {};
    els.dynamicOptions.querySelectorAll('[data-wbc-option-group]').forEach(group => {
      const pos = group.dataset.optionPosition;
      const selectedBtn = group.querySelector('[data-wbc-option-value].is-selected');
      if (selectedBtn) ids[pos] = selectedBtn.dataset.optionValueId;
    });
    return ids;
  }

  function handleOptionValueChange(position, newValueId) {
    const ids = collectSelectedOptionValueIds();
    ids[position] = newValueId;
    const orderedIds = Object.keys(ids)
      .sort((a, b) => Number(a) - Number(b))
      .map(k => ids[k]);
    const url = `${state.productUrl}?option_values=${orderedIds.join(',')}&section_id=${window.__WBC_SECTION_ID__}`;
    refreshSection(url);
  }

  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wbc-option-value]');
    if (!btn || btn.disabled || btn.classList.contains('is-disabled')) return;
    handleOptionValueChange(btn.dataset.optionPosition, btn.dataset.optionValueId);
  });

  root.addEventListener('change', (e) => {
    const select = e.target.closest('[data-wbc-metal-select]');
    if (!select || !select.value) return;
    handleOptionValueChange(select.dataset.optionPosition, select.value);
  });

  function clampQty(value) {
    if (isNaN(value)) return 1;
    return Math.min(WBC_MAX_QTY, Math.max(1, value));
  }

  function updateQtyControls() {
    const qty = parseInt(els.qtyInput.value || '1', 10);
    els.qtyIncrease.disabled = qty >= WBC_MAX_QTY;
    els.qtyDecrease.disabled = qty <= 1;
  }

  els.qtyIncrease.addEventListener('click', () => {
    els.qtyInput.value = clampQty(parseInt(els.qtyInput.value || '1', 10) + 1);
    els.qtyError.hidden = true;
    updateTotalPrice();
    updateQtyControls();
  });
  els.qtyDecrease.addEventListener('click', () => {
    els.qtyInput.value = clampQty(parseInt(els.qtyInput.value || '1', 10) - 1);
    els.qtyError.hidden = true;
    updateTotalPrice();
    updateQtyControls();
  });
  els.qtyInput.addEventListener('change', () => {
    const raw = parseInt(els.qtyInput.value, 10);
    els.qtyInput.value = clampQty(raw);
    els.qtyError.hidden = true;
    updateTotalPrice();
    updateQtyControls();
  });

  els.addToCart.addEventListener('click', async () => {
    const variantId = els.addToCart.dataset.variantId;
    if (!variantId || els.addToCart.disabled) return;

    const selectedShape = (state.shape || '').trim();
    const selectedBandStyle = (state.style || '').trim();

    if (!selectedShape || !selectedBandStyle) {
      console.error('Shape or Band Style is missing.');
      return;
    }

    const labelEl = els.addToCart.querySelector('.wbc__atc-label');
    const originalLabel = labelEl ? labelEl.textContent : els.addToCart.textContent;

    // Loader ON — button disable, text hide, spinner spin
    els.addToCart.classList.remove('is-added');
    els.addToCart.classList.add('is-loading');
    els.addToCart.disabled = true;

    try {
      const quantity = clampQty(parseInt(els.qtyInput.value || '1', 10));
      const properties = {
        'Shape': capitalize(selectedShape),
        'Band Style': capitalize(selectedBandStyle)
      };

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: quantity,
          properties: properties
        })
      });

      const data = await res.json();
      if (!res.ok) {
        console.error('Cart Add Error:', data);
        throw new Error(data.description || 'Add to cart failed');
      }

      document.dispatchEvent(
        new CustomEvent('wbc:added-to-cart', {
          detail: data
        })
      );

      // Loader OFF -> success state
      els.addToCart.classList.remove('is-loading');
      els.addToCart.classList.add('is-added');
      if (labelEl) labelEl.textContent = 'Added ✓';

      setTimeout(() => {
        els.addToCart.classList.remove('is-added');
        if (labelEl) labelEl.textContent = originalLabel;
        els.addToCart.disabled = false;
      }, 1500);

    } catch (err) {
      console.error('[wbc] Add to cart error:', err);
      els.addToCart.classList.remove('is-loading');
      if (labelEl) labelEl.textContent = 'Try Again';
      setTimeout(() => {
        if (labelEl) labelEl.textContent = originalLabel;
        els.addToCart.disabled = false;
      }, 1500);
    }
  });

  function setLoading(isLoading) {
    els.loading.hidden = !isLoading;
  }

  function showUnavailable(isUnavailable) {
    els.unavailable.hidden = !isUnavailable;
    els.addToCart.disabled = isUnavailable;
  }

  function initTabs() {
    if (!els.tabButtons.length) return;

    els.tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetTab = btn.getAttribute('data-wbc-tab');

        els.tabButtons.forEach(b => b.classList.remove('is-active'));
        els.tabPanes.forEach(p => p.classList.remove('is-active'));

        btn.classList.add('is-active');
        const targetPane = tabsRoot.querySelector(`[data-wbc-tab-content="${targetTab}"]`);
        if (targetPane) {
          targetPane.classList.add('is-active');
        }
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------------------
  renderShapeButtons();
  renderStyleButtons();
  applyMetalSwatchStyling();
  updateMmCaptionFromDom();

  if (els.currentPrice && els.currentPrice.dataset.unitPriceCents) {
    state.unitPrice = parseInt(els.currentPrice.dataset.unitPriceCents, 10);
  }

  // Seed media list from initial DOM (Images pehle, Video last me)
  state.media = buildMediaList(root);
  updateGallery();

  updateTotalPrice();
  updateQtyControls();
  initTabs();

  const initialTargetHandle =
    comboMap[normalize(state.shape)] && comboMap[normalize(state.shape)][normalize(state.style)];

  if (initialTargetHandle && initialTargetHandle !== state.currentHandle) {
    refreshSection(`/products/${initialTargetHandle}?section_id=${window.__WBC_SECTION_ID__}`);
  }

  // Quietly buffer THIS page's own video starting right now, at low network
  // priority — a first-time visitor has no cache at all, so this needs the
  // maximum possible head start before they click the video thumbnail.
  preloadMainVideoInBackground(true);
  // Warm the cache for every other combo in idle time, so switching feels instant.
  prefetchCombos();

})();